import { Component } from '@angular/core';

@Component({
  selector: 'app-item-search-dialog',
  templateUrl: 'item-search.dialog.html',
  styleUrls: ['./item-search.dialog.scss']
})
export class ItemSearchDialogComponent {}
